import React from 'react';
import classNames from 'classnames';
import { ButtonProps } from './Button';

type Props = ButtonProps & {
  noBorder?: boolean;
  noMargin?: boolean;
};

const PrimaryLink = ({ children, className, icon, disabled, noBorder, noMargin, dark, loading, ...rest }: Props) => (
  <button
    type="button"
    className={classNames('primary-link', className, { disabled: disabled || loading, dark, 'no-border': noBorder, 'no-margin': noMargin })}
    disabled={disabled || loading}
    {...rest}
  >
    {icon && !loading && <i className={`icon-${icon}`} />}
    {loading && <i className="icon-spinner" />}

    {children}
  </button>
);

export default PrimaryLink;
